export const RATING_URL = process.env.REACT_APP_RATING_URL || 'https://userratingdev.azure.platform.porsche-preview.cloud/'
export const API_URL = process.env.REACT_APP_API_URL || 'https://userratingdev.azure.platform.porsche-preview.cloud/api/rate?'
export const TOAST_TIME = 3000
export const SCOPE_API = 'api://63a8c28a-6162-4b5d-b552-9bd792ff3d2d/Rating.Manage'
export const CLIENT_ID = '63a8c28a-6162-4b5d-b552-9bd792ff3d2d'
export const AUTHORITY = 'https://login.microsoftonline.com/56564e0f-83d3-4b52-92e8-a6bb9ea36564'
export const TEST = false
